import React from "react";
import Service from '../../service/Service';
import * as actions from './Actions';

export default function ShareOptions({ feedItem, eleRef }) {
    return (

        <div className="sharing-options due-date-share">
        {feedItem.type=="articles" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', feedItem.data[0].articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', feedItem.data[0].articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', feedItem.data[0].articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', feedItem.data[0].articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        
        }

        {feedItem.type=="multiplearticles" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        
        }

        {feedItem.type=="quiz" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.redirectUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg gtm-quiz-fb" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.redirectUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg gtm-quiz-twitter" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.redirectUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg gtm-quiz-pntrest" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.redirectUrl)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg gtm-quiz-whtapp" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        
        }


        {feedItem.type=="video" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', feedItem.data[0].url)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg gtm-video-fb" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', feedItem.data[0].url)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg gtm-video-twitter" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', feedItem.data[0].url)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg gtm-video-pintrest" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', feedItem.data[0].url)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg gtm-video-whatsapp" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }

         {feedItem.type=="memoriesview" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png' className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png' className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png' className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/memories/photodetails/'+feedItem.data[0].memoryId)}>
                    <div className="M16_61 social-share">
                        <img  src='https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png' className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }
	
{feedItem.type=="dietplanmom" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }
	 {feedItem.type=="writeforus" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', eleRef.articleUrl)}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }


        {feedItem.type=="weekbyweekfataldevelopement" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/pregnancy-week-by-week-tracker/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }

        {feedItem.type=="Babysizecomparison" && 
            <ul>
                <li className="facebook-share left" onClick={() => actions.shareVideo('facebook', 'https://parenting.firstcry.com/tools/baby-size-comparison/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/facebook.png" className="loadingImg facebookimg gtm-babysize-fb" alt="Facebook Icon" title="Facebook Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('twitter', 'https://parenting.firstcry.com/tools/baby-size-comparison/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/twitter.png" className="loadingImg twitterimg gtm-babysize-twitter" alt="Twitter Icon" title="Twitter Icon" />
                    </div>
                </li>
                <li className="twitter-share left" onClick={() => actions.shareVideo('pintrest', 'https://parenting.firstcry.com/tools/baby-size-comparison/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/pintrest.png" className="loadingImg pintrestimg gtm-babysize-pntrest" alt="Pintrest Icon" title="Pintrest Icon" />
                    </div>
                </li>
                <li className="whatsapp-share left" onClick={() => actions.shareVideo('whatsapp', 'https://parenting.firstcry.com/tools/baby-size-comparison/')}>
                    <div className="M16_61 social-share">
                        <img  src="https://cdn.cdnparenting.com/brainbees/community/preact/public/media/whatsapp.png" className="loadingImg whatsappimg gtm-babysize-whsapp" alt="Whatsapp Icon" title="Whatsapp Icon" />
                    </div>
                </li>
            </ul>
        }




        



        
        </div>

    );
}
